import { message } from "antd";

export class PotreeFunc {
    static angleMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: false,
            showAngles: true,
            showArea: false,
            closed: true,
            maxMarkers: 3,
            name: 'Angle'
        });
    }
    static pointMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: false,
            showAngles: false,
            showCoordinates: true,
            showArea: false,
            closed: false,
            maxMarkers: 1,
            name: 'Point'
        });
        measurement.spheres[0]?.addEventListener("click", (e: any) => {
            if(e.mEvent?.which !== 3) return; // NOTE: Potree code edited to add mEvent
            const position = e.target?.position?.toArray() || ""
            if (position) {
                navigator.clipboard.writeText(position.join(",")).then(function () {
                    message.success('Copied to clipboard');
                }, function (err) {
                });
            }
        });
    }
    static distanceMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: true,
            showArea: false,
            closed: false,
            // maxMarkers: 2,
            name: 'Distance'
        });
    }
    static heightMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: true,
            showHeight: true,
            showArea: false,
            closed: false,
            maxMarkers: 2,
            name: 'Height'
        });
    }
    static circleMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: false,
            showHeight: false,
            showArea: false,
            showCircle: true,
            showEdges: false,
            closed: false,
            maxMarkers: 3,
            name: 'Circle'
        });
    }
    static azimuthMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: false,
            showHeight: false,
            showArea: false,
            showCircle: false,
            showEdges: false,
            showAzimuth: true,
            closed: false,
            maxMarkers: 2,
            name: 'Azimuth'
        });
    }
    static areaMeasurement() {
        let measurement = window.potreeViewer.measuringTool.startInsertion({
            showDistances: true,
            showArea: true,
            closed: true,
            name: 'Area'
        });
    }
    static volumeMeasurement() {
        let volume = window.potreeViewer.volumeTool.startInsertion()

    }
    static removeAll() {
        window.potreeViewer.scene.removeAllMeasurements();
    }
}
